import React, { useState } from "react";
import {
  Grid,
  Card,
  Typography,
  Box,
  Button,
  Breadcrumbs,
} from "@mui/material";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import SourceIcon from "@mui/icons-material/Source";
import MapIcon from "@mui/icons-material/Map";
import CategoryIcon from "@mui/icons-material/Category";
import PersonIcon from "@mui/icons-material/Person";
import CSEComponent from "./CSEComponent";
import BDMComponent from "./BDMComponent";
import ZMComponent from "./ZMComponent";
import SourceOfLeadComponent from "./SourceOfLeadComponent";
import CategorySubCategoryComponent from "./CategorySubCategoryComponent";
import RegionComponent from "./RegionComponent";
import EmployeeComponent from "./EmployeeComponent";
import { Link, useNavigate } from "react-router-dom";
import { Building2, Map, UserCog } from "lucide-react";

function SettingsComponent() {
  const [selectedItem, setSelectedItem] = useState(null);
  const [label, setLabel] = useState("");

  const navigate = useNavigate();

  const menuItems = [
    {
      label: "Campaign Master",
      icon: <AccountBoxIcon />,
      route: "/admin/campaigns",
    },
    {
      label: "Region Mapping",
      icon: <AddLocationAltIcon />,
      route: "/admin/regions",
    },
    {
      label: "Employee Master",
      icon: <PersonIcon />,
      route: "/admin/employees",
    },
    {
      label: "Category Master",
      icon: <CategoryIcon />,
      route: "/admin/category",
    },
    {
      label: "SubCategory Master",
      icon: <CategoryIcon />,
      route: "/admin/subcategory",
    },
    {
      label: "RO/BO Master",
      icon: <AddLocationAltIcon />,
      route: "/admin/robomaster",
    },
    {
      label: "Region Management",
      icon: <AddLocationAltIcon />,
      route: "/admin/region-management",
    },
    {
      label: "Buisness Management",
      icon: <Building2 />,
      route: "/admin/buisness",
    },
    {
      label: "Role Master",
      icon: <UserCog />,
      route: "/admin/role-master",
    },
    {
      label: "State Master",
      icon: <Map />,
      route: "/admin/state-master",
    },
    {
      label: "Pincode Master",
      icon: <Map />,
      route: "/admin/pincode-master",
    },
  ];

  const handleClick = (item) => {
    setLabel(item.label);

    navigate(item.route);
  };

  const handleBack = () => {
    setSelectedItem(null);
  };

  return (
    <>
      <>
        <Typography sx={{ fontWeight: 700, fontSize: "2rem", mb: 3 }}>
          Admin Panel
        </Typography>
        <Grid container spacing={3}>
          {menuItems.map((item) => (
            <Grid item xs={12} sm={6} md={3} key={item.label}>
              <Card
                sx={{
                  cursor: "pointer",
                  padding: 3,
                  textAlign: "center",
                  boxShadow: 3,
                  borderRadius: 2,
                  backgroundColor: "#f5f5f5", // Subtle background color for contrast
                  "&:hover": {
                    boxShadow: 6,
                    backgroundColor: "#e0e0e0", // Slightly darker on hover
                  },
                }}
                onClick={() => handleClick(item)}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  {item.icon}
                </Box>
                <Typography
                  sx={{
                    fontSize: "1.2rem",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.label}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </>
    </>
  );
}

export default SettingsComponent;
